export const SHOPIFY_SSO_TOKEN_KEY = "pivony_shopify_sso_token";

export async function consumeShopifySsoToken(token, verifyUrl) {
  if (!token || !verifyUrl) {
    return { ok: false };
  }
  try {
    const url = new URL(verifyUrl);
    url.searchParams.set("token", token);
    const response = await fetch(url.toString(), {
      method: "GET",
      credentials: "omit",
    });
    if (!response.ok) {
      return { ok: false };
    }
    const data = await response.json();
    if (!data || typeof data.shop !== "string" || !data.shop.trim()) {
      return { ok: false };
    }
    return { ok: true, shop: data.shop.trim() };
  } catch (_) {
    return { ok: false };
  }
}
